import { TripApi } from "../../Types/Generated/LogbookApi/TripApi"
import type { ITripResponse } from "../../Types/Generated/LogbookModel/Trip"
import { entity } from "./Connection"
import { IStoredCalculationSource } from "../../Types/Generated/LogbookModel/StoredCalculation"
import {
  applyCalculationResults,
  calculationFolds,
  calculationProjectionFields,
  preserveCalculationProjection,
  tripNotableFolds,
} from "./Folds"

export function tripResponseEntity(response: ITripResponse, previous?: ITripResponse["trip"]) {
  return preserveCalculationProjection(applyCalculationResults(
    [response.trip],
    response.calculation ? [response.calculation] : [],
    response.calculationV2 ? [response.calculationV2] : [],
  )[0], previous);
}

export const TripEntity = entity("Trip", {
  sort: (a, b) => a.id - b.id,
  preserveLive: calculationProjectionFields,
  fetch: (client, ids) => {
    const { shipId, cruiseId } = ids;
    if (shipId === undefined || cruiseId === undefined) {
      return Promise.reject(new Error("Trip fetch requires shipId and cruiseId"));
    }
    return new TripApi(client).trips.list({ params: { shipId, cruiseId } }).call().then((response) => ({
      entities: {
        Trip: applyCalculationResults(
          response.trips ?? [],
          response.calculations ?? [],
          response.calculationsV2 ?? [],
        ),
        Note: response.notes ?? [],
        NoteAttachment: response.attachments ?? [],
      },
    }));
  },
  folds: {
    ...calculationFolds(IStoredCalculationSource.trip),
    ...tripNotableFolds,
  },
});
